export const FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL = 'FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL';
export const FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE';

export const GENERATE_R2R_CHART = 'GENERATE_R2R_CHART';
export const GENERATE_R2R_CHART_SUCCESS = 'GENERATE_R2R_CHART_SUCCESS';
export const GENERATE_R2R_CHART_FAILURE = 'GENERATE_R2R_CHART_FAILURE';
